export default "__VITE_PUBLIC_ASSET__6e14ddd6__"